<template>
    <div>
        <form-header
            title="Tage der Musikschulen"
            subtitle=""
            tag=""
        >
        </form-header>
        <ValidationObserver ref="form">
            <div class="bg-primary">
                <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                    <transition name="fade">
                        <div
                            class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
                            v-show="formbehaviour.alertrequired"
                        >
                            <div class="md:grid md:grid-cols-1 md:gap-3">
                                <div class="md:col-span-1">
                                    <h3 class="leading-3">
                                        Bitte überprüfen Sie Ihre Eingabe!
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </transition>

                    <form-section title="Registrierung für Musikschule/Kreativakademie">
                        <drop-down
                            label="Musikschule/Kreativakademie"
                            v-model="ansuchen.musikschuleId"
                            rules="required"
                            :values="formdata.musikschulen"
                        ></drop-down>
                    </form-section>
                    <form-section title="Kontaktperson">
                        <text-input
                            label="Titel (vor.)"
                            v-model="ansuchen.prefix"
                            rules=""
                            columns="1"
                        ></text-input>
                        <text-input
                            label="Vorname"
                            v-model="ansuchen.vorname"
                            rules="required"
                            columns="2"
                        ></text-input>
                        <text-input
                            label="Nachname"
                            v-model="ansuchen.nachname"
                            rules="required"
                            columns="2"
                        ></text-input>
                        <text-input
                            label="Titel (nach.)"
                            v-model="ansuchen.suffix"
                            rules=""
                            columns="1"
                        ></text-input>
                        <text-input
                            label="Telefon"
                            v-model="ansuchen.telefon"
                            rules=""
                            columns="3"
                        ></text-input>
                        <text-input
                            label="E-Mail-Adresse"
                            v-model="ansuchen.email"
                            rules="required"
                            columns="3"
                        ></text-input>
                    </form-section>
                    <div
                        v-for="(veranstaltung,
                        index) in ansuchen.veranstaltungen"
                        :key="index"
                    >
                        <form-section :title="index + 1 + '. Veranstaltung'">
                            <text-input
                                label="Titel"
                                v-model="veranstaltung.titel"
                                rules="required"
                            ></text-input>
                            <text-area-input
                                label="Beschreibung"
                                v-model="veranstaltung.zusatztext"
                                rules="max:300"
                                tooltip="max. 300 Zeichen inklusive Leerzeichen"
                            ></text-area-input>
                            <text-input
                                label="Datum der Veranstaltung"
                                v-model="veranstaltung.datum"
                                rules="required|date"
                            ></text-input>
                            <drop-down
                                label="Uhrzeit Von"
                                :values="zeitbereich"
                                v-model="veranstaltung.uhrzeitVonId"
                                rules="required"
                            ></drop-down>
                            <drop-down
                                label="Uhrzeit Bis"
                                :values="zeitbereich"
                                v-model="veranstaltung.uhrzeitBisId"
                                rules="required"
                            ></drop-down>
                            <text-input
                                label="Veranstaltungsort"
                                v-model="veranstaltung.ort"
                                rules="required"
                            ></text-input>
                            <text-input
                                label="Straße"
                                v-model="veranstaltung.strasse"
                                rules="required"
                            ></text-input>
                            <text-input
                                label="Postleitzahl"
                                v-model="veranstaltung.plz"
                                rules="required|numeric|length:4"
                            ></text-input>
                            <drop-down
                                label="Gemeinde"
                                v-model="veranstaltung.gemeindeId"
                                :values="formdata.gemeinden"
                                rules="required"
                            ></drop-down>
                            <text-input
                                label="Webadresse"
                                rules="required"
                                v-model="veranstaltung.webadresse"
                            ></text-input>
                            <button
                                v-show="index != 0"
                                @click="removeVeranstaltung(index)"
                                type="button"
                                class="col-span-3 text-center sm:px-2 py-1 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-red active:bg-red-700 transition ease-in-out duration-150"
                            >
                                Veranstaltung entfernen
                            </button>
                        </form-section>
                    </div>
                    <div
                        class="mb-6 mt-2 bg-white shadow px-4 py-4 sm:rounded-lg sm:p-4"
                    >
                        <div class="md:grid md:grid-cols-3 md:gap-6">
                            <div class="md:col-span-1">&nbsp;</div>
                            <div class="grid grid-cols-6 gap-6">
                                <div class="col-span-6">
                                    <span
                                        class="inline-flex rounded-md shadow-sm"
                                    >
                                        <button
                                            @click="addVeranstaltung"
                                            type="button"
                                            class="inline-flex items-center px-48 sm:px-4 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150"
                                        >
                                            Weitere Veranstaltung hinzufügen
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <form-section title="Sonstiges">
                        <check-box
                            class="col-span-6"
                            label="Wir benötigen für die aktuellen Tage der Musikschulen neue Werbemittel."
                            v-model="ansuchen.werbemittelBenoetigt"
                        ></check-box>
                    </form-section>
                    <form-section title="Bestätigung">
                        <check-box
                            label="Ich bestätige hiermit die Richtigkeit meiner Angaben"
                            v-model="formdata.checkAngaben"
                            class="col-span-6"
                            rules="required"
                        ></check-box>
                    </form-section>
                    <form-section
                        title="Bestätigung senden an"
                        subtitle="Bitte geben Sie die E-Mailadresse an, an welche die Eingangsbestätigung gesendet werden soll."
                    >
                        <button
                            @click="
                                ansuchen.bestaetigungsemail = ansuchen.email
                            "
                            type="button"
                            class="block mt-3 text-center col-span-6 md:col-span-2 px-48 sm:px-4 py-2 border border-transparent text-xs font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150"
                        >
                            E-Mailadresse von Kontaktperson übernehmen
                        </button>
                        <div class="col-span-4"></div>
                        <text-input
                            label="E-Mail-Adresse"
                            v-model="ansuchen.bestaetigungsemail"
                            rules="required"
                            columns="3"
                        ></text-input>
                    </form-section>
                    <div
                        class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6"
                    >
                        <div class="md:grid md:grid-cols-3 md:gap-6">
                            <div class="md:col-span-1">&nbsp;</div>
                            <div class="grid grid-cols-6 gap-6">
                                <div class="col-span-6">
                                    <span
                                        class="inline-flex rounded-md shadow-sm"
                                    >
                                        <button
                                            @click="sendAnsuchen()"
                                            type="button"
                                            class="inline-flex items-center px-48 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150"
                                        >
                                            Anmelden
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>
        <transition name="fade">
            <div
                class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end"
            >
                <div
                    v-show="formbehaviour.sending"
                    class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto"
                >
                    <div class="rounded-lg shadow-xs overflow-hidden">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0">
                                    <svg
                                        class="h-6 w-6 text-green-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p
                                        class="text-sm leading-5 font-medium text-gray-900"
                                    >
                                        Validierung erfolgreich.
                                    </p>
                                    <p
                                        class="mt-1 text-sm leading-5 text-gray-500"
                                    >
                                        Übermittle die Anmeldung.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                v-show="formbehaviour.successful"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
            >
                <div
                    v-show="formbehaviour.successful"
                    class="fixed inset-0 transition-opacity"
                >
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div
                    v-show="formbehaviour.successful"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6"
                >
                    <div>
                        <div
                            class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100"
                        >
                            <svg
                                class="h-6 w-6 text-green-600"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="text-lg leading-6 font-medium text-gray-900"
                            >
                                Erfolgreich gesendet.
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Sie können das Fenster nun schließen
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import FormHeader from '@/components/forms/FormHeader.vue'
import FormSection from '@/components/forms/FormSection.vue'
import DropDown from '@/components/inputs/DropDown.vue'
import TextInput from '@/components/inputs/TextInput.vue'
import TextAreaInput from '@/components/inputs/TextAreaInput.vue'
import CheckBox from '@/components/inputs/CheckBox.vue'
import TextBlock from '@/components/inputs/TextBlock.vue'

export default {
    name: 'Form',
    inject: ['service'],
    data: function () {
        return {
            formbehaviour: {
                alertrequired: false,
                showSendModal: false,
                openSubmitModal: false,
                sending: false,
                successful: false,
            },
            formdata: {
                musikschulen: [],
                gemeinden: [],
                checkAngaben: null,
                textbausteine: [],
            },
            ansuchen: {
                bestaetigungsemail: null,
                vorname: null,
                nachname: null,
                telefon: null,
                email: null,
                prefix: null,
                suffix: null,
                veranstaltungen: [],
                musikschuleId: null,
                gewinnspielFluegelGroesse: null,
                gewinnspielTeilnahme: false,
                werbemittelBenoetigt: false,
            },
            zeitbereich: [],
        }
    },
    components: {
        FormHeader,
        FormSection,
        DropDown,
        TextInput,
        TextAreaInput,
        CheckBox,
        TextBlock,
    },
    methods: {
        addVeranstaltung() {
            this.ansuchen.veranstaltungen.push({
                datum: null,
                rahmenZeitVon: null,
                rahmenZeitBis: null,
                uhrzeitVonId: null,
                uhrzeitBisId: null,
                titel: null,
                ort: null,
                strasse: null,
                plz: null,
                gemeindeId: null,
                webadresse: null,
                zusatztext: null,
            })
        },
        removeVeranstaltung(index) {
            this.ansuchen.veranstaltungen.splice(index, 1)
        },
        setupZeitbereich() {
            let hour
            let minutes
            for (let i = 0; i < 48; i++) {
                hour = Math.floor(0 + i * 0.5)
                if (hour < 10) {
                    hour = '0' + String(hour)
                }
                minutes = i % 2 == 0 ? '00' : '30'
                this.zeitbereich.push({ id: i, name: `${hour}:${minutes}` })
            }
        },
        async fetchTextbausteine() {
            const { data } = await this.service.formular
                .get('tdm')
                .textbloeckePowerApps()
            this.formdata.textbausteine = data
        },
        textbausteinfuer(id) {
            const found = this.formdata.textbausteine.find(
                (element) => element.identifier == id
            )
            if (!found) return id

            return found.content
        },
        async fetchGemeinden() {
            const { data } = await this.service.gemeinde.alle()

            this.formdata.gemeinden = data
            this.formdata.gemeinden.sort((a, b) => (a.name > b.name ? 1 : -1))
        },
        async fetchMusikschulen() {
            const { data } = await this.service.musikschule.powerAppsAlle()
            this.formdata.musikschulen = data
            this.formdata.musikschulen.sort((a, b) =>
                a.kurzbezeichnung > b.kurzbezeichnung ? 1 : -1
            )
        },
        async sendAnsuchen() {
            var validation = await this.$refs.form.validate()
            var veranstaltung
            for (let i = 0; i < this.ansuchen.veranstaltungen.length; i++) {
                veranstaltung = this.ansuchen.veranstaltungen[i]
                veranstaltung.rahmenZeitVon = this.zeitbereich[
                    veranstaltung.uhrzeitVonId
                ].name
                veranstaltung.rahmenZeitBis = this.zeitbereich[
                    veranstaltung.uhrzeitBisId
                ].name
            }
            if (!validation) {
                window.scrollTo(0, 0)
                this.formbehaviour.alertrequired = true
                return
            }

            this.formbehaviour.sending = true
            await this.service.tdm.senden(this.ansuchen)
            this.formbehaviour.sending = false
            this.formbehaviour.successful = true
        },
    },
    created() {
        this.addVeranstaltung();
        this.setupZeitbereich();
        this.fetchGemeinden();
        this.fetchMusikschulen();
        this.fetchTextbausteine();
    },
}
</script>
